/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import gql from 'graphql-tag';

import { USER_LISTING_PREFERENCES_FRAGMENT } from './fragments';

export const SAVE_USER_LISTING_PREFERENCES_MUTATION = gql`
  mutation SaveUserListingPreferences(
    $state: UserListingPreferencesState!
    $userPreferences: UserListingPreferencesData!
  ) {
    saveUserListingPreferences(state: $state, data: $userPreferences) {
      result {
        ...UserListingPreferencesFields
      }
    }
  }
  ${USER_LISTING_PREFERENCES_FRAGMENT}
`;

export const DELETE_USER_LISTING_PREFERENCES_MUTATION = gql`
  mutation DeleteUserListingPreferences(
    $state: UserListingPreferencesState!
    $userPreferencesToDelete: [ListingPreferenceFields]
  ) {
    deleteUserListingPreferences(state: $state, data: $userPreferencesToDelete) {
      result {
        ...UserListingPreferencesFields
      }
    }
  }
  ${USER_LISTING_PREFERENCES_FRAGMENT}
`;
